import Dialog from "dialog";
import template from "./dialog-config.html";
import css from "./dialog-config.css";

class ConfigCO2Dialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-co2", ConfigCO2Dialog);
  }
  constructor() {
    super();

    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

    this.onupdatedevices_handler({detail: application.devices});

    this.show();
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.gssco2.id;
    this.textboxDeviceStatus.value = devices.gssco2.status;
    this.textboxValue.value = devices.gssco2.value;
    this.textboxTemperature.value = devices.gssco2.temperature;
    this.textboxRelativeHumidity.value = devices.gssco2.relativeHumidity;
  }
  buttonClose_click(event) {
    this.close();
  }
  async buttonCalibrateNitrogen_click(event) {
    try {
      this.buttonCalibrateNitrogen.icon.iconname = "view-refresh";
      await server.rcall("RM_gssco2_calibratenitrogen");
      this.buttonCalibrateNitrogen.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateNitrogen.icon.iconname = "process-stop";
    }
  }
  async buttonCalibrateFreshAir_click(event) {
    try {
      this.buttonCalibrateFreshAir.icon.iconname = "view-refresh";
      await server.rcall("RM_gssco2_calibratefreshair");
      this.buttonCalibrateFreshAir.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateFreshAir.icon.iconname = "process-stop";
    }
  }
  async buttonCalibrateKnownGas_click(event) {
    try {
      this.buttonCalibrateKnownGas.icon.iconname = "view-refresh";
      await server.rcall("RM_gssco2_calibrateknowngas", parseInt(this.textboxCalibrateKnownGas.value));
      this.buttonCalibrateKnownGas.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrateKnownGas.icon.iconname = "process-stop";
    }
  }
  close() {
    super.close();
  }
}

ConfigCO2Dialog.constructor();

export default ConfigCO2Dialog;